export const PREDEFINED_ROLES = [
  "Product Designer",
  "Software Engineer",
  "Artist",
  "Content Creator",
  "Digital Nomad",
  "UX Researcher"
];